import React from "react";
import { inp, lbl } from "../shared";
import { GENDERS, COMPLEXITY, CHARACTER, CLASS_TITLES } from "../../../lib/classifications";

const OPTIONS = [
  ["gender", GENDERS],
  ["complexity", COMPLEXITY],
  ["character", CHARACTER],
];

export const ClassificationFields = ({ p, set }) => (
  <div className="md:col-span-2 border border-[#262421] p-4 mt-1">
    <label className={lbl + " !mb-3"}>Classification · التصنيف</label>
    <div className="grid md:grid-cols-3 gap-4">
      {OPTIONS.map(([field, list]) => (
        <div key={field}>
          <label className={lbl}>{CLASS_TITLES[field].en} · {CLASS_TITLES[field].ar}</label>
          <select value={p[field] || ""} onChange={(e) => set(field, e.target.value)} data-testid={`pf-${field}`} className={inp}>
            <option value="">— Not set · غير محدد —</option>
            {list.map((o) => <option key={o.key} value={o.key}>{o.en} · {o.ar}</option>)}
          </select>
        </div>
      ))}
    </div>
  </div>
);
